import { useEffect, useRef, useState } from "react";
import Editor from "./editor";
import { Link } from "react-router-dom";

const MediaCard = (props: any) => {
  const { cardType, onClick, className } = props;
  const [data, setData] = useState({ ...props });
  useEffect(() => {
    setData({ ...props });
  }, [props]);
  const mediaCardRef = useRef<HTMLDivElement | null>(null);
  const [isWidthGreater, setIsWidthGreater] = useState(false);
  const [isWidthSmaller, setIsWidthSmaller] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const toggleLike = () => {
    // Update the data immutably
    setData((prevData: any) => ({
      ...prevData,
      isLiked: !prevData.isLiked,
      nLike: prevData.isLiked ? prevData.nLike - 1 : prevData.nLike + 1,
    }));
  };
  // Function to check the width and set the flag
  const checkWidth = () => {
    if (mediaCardRef.current) {
      const cardWidth = mediaCardRef.current.getBoundingClientRect().width;
      setIsWidthGreater(cardWidth > 400);
      setIsWidthSmaller(cardWidth < 360);
    }
  };

  // Use useEffect to check the width of the mediaCardRef
  // useEffect to handle mounting and browser resizing
  useEffect(() => {
    // Check the initial width when the component mounts
    checkWidth();

    // Add resize event listener
    const handleResize = () => {
      checkWidth();
    };

    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []); // Empty dependency array ensures this effect runs only once // Run once when the component mounts
  const sendMessage = (message: any) => {
    let newMessage = {
      _id: data?.comments?.length,
      user: {
        name: "Guest",
        avatar: "/img/guest.webp",
      },
      created: "",
      content: message,
      isLiked: false,
      nLike: 0,
    };
    let updatedData = { ...data };
    updatedData.comments.push(newMessage);
    setData(updatedData);
  };
  const handleCommentLike = (d: any) => {
    let commentData = { ...d };
    if (commentData?.isLiked) {
      commentData.isLiked = false;
      commentData.nLike -= 1;
    } else {
      commentData.isLiked = true;
      commentData.nLike += 1;
    }
    let updatedData = { ...data };
    if (
      updatedData.comments[
        updatedData.comments?.findIndex((c: any) => c._id == d._id)
      ]
    ) {
      updatedData.comments[
        updatedData.comments?.findIndex((c: any) => c._id == d._id)
      ] = commentData;
    }
    setData(updatedData);
  };
  const handleFavorite = () => {
    let updatedData = { ...data };
    if (updatedData?.isFavorite) {
      updatedData.isFavorite = false;
    } else {
      updatedData.isFavorite = true;
    }
    setData(updatedData);
  };
  const getComments = (): any[] => {
    if (showAll || cardType === "detail") {
      return data?.comments;
    } else {
      return data?.comments[data?.comments?.length - 1]
        ? [data?.comments[data?.comments?.length - 1]]
        : [];
    }
  };
  return (
    <>
      <div
        className={`bg-[#5E5144] ${className} ${
          cardType !== "detail" ? "rounded-3xl" : "rounded-3xl flex flex-col"
        } text-white`}
        ref={mediaCardRef}
      >
        {cardType != "detail" && (
          <img
            src={data.cover}
            alt={data.title}
            className="w-full object-cover object-center rounded-t-3xl aspect-[345/236]"
            onClick={onClick}
          />
        )}
        <div
          className={`px-4 py-3 ${
            cardType === "detail" ? "flex-grow flex flex-col" : ""
          }`}
        >
          <div className={`flex justify-start items-center gap-1`}>
            <span
              className={`text-lg font-medium text-[#B7B9D2]  ${
                isWidthSmaller ? "text-sm" : " "
              }`}
            >
              {data.title} -
            </span>
            <span
              className={`text-lg font-medium  ${
                isWidthSmaller ? "text-sm" : " "
              }`}
            >
              {data.subtitle}
            </span>
          </div>
          <div
            className={`select-none font-semibold ${
              cardType === "detail" ? "" : "mt-3"
            }`}
          >
            <div
              className={`relative text-white space-y-2 ${
                isWidthSmaller
                  ? "text-[9px]"
                  : isWidthGreater
                  ? "text-sm"
                  : "text-xs"
              }`}
            >
              <div
                className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 leading-none`}
              >
                <span className="whitespace-nowrap">
                  Released on: {data.published}
                </span>
              </div>
              <div
                className={`flex justify-between items-center  rounded-2xl`}
                style={{ backgroundColor: data?.color }}
              >
                <span
                  className={` ${
                    isWidthSmaller ? "w-[28%] " : "w-[28%] "
                  } flex justify-center items-center py-1`}
                >
                  {data.type}
                </span>
                <span
                  className={`flex justify-center items-center gap-1 ${
                    isWidthSmaller ? "w-[28%]" : "w-[28%] "
                  } flex-shrink-0 py-1`}
                >
                  <span className="whitespace-nowrap">Country : </span>
                  <img
                    src={`/img/flags/${data.country}.svg`}
                    className={`${isWidthSmaller ? "h-3" : "h-4"}`}
                  />
                </span>
              </div>
            </div>
          </div>
          <div className="mt-4 flex justify-center gap-3">
            <span className="w-7 h-7 inline-flex rounded-full flex-shrink-0 justify-center items-center bg-[#28241F] hover:bg-opacity-75 cursor-pointer">
              <svg
                width="15"
                height="14"
                viewBox="0 0 15 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.97672 0.0583577C9.07384 0.0110685 9.18234 -0.00807605 9.28985 0.00310619C9.39736 0.0142884 9.49956 0.0553476 9.58479 0.121604L14.777 4.14635C14.8439 4.19817 14.8986 4.26404 14.9371 4.3393C14.9756 4.41455 14.9969 4.49733 14.9997 4.58175C15.0024 4.66617 14.9865 4.75016 14.953 4.82775C14.9195 4.90534 14.8692 4.97461 14.8058 5.03065L9.61363 9.63036C9.53048 9.70395 9.42776 9.75202 9.31783 9.76879C9.20791 9.78555 9.09546 9.7703 8.99403 9.72486C8.8926 9.67942 8.80651 9.60573 8.74612 9.51266C8.68574 9.4196 8.65362 9.31112 8.65365 9.20029V6.96483C8.38135 7.01082 8.02598 7.09132 7.6106 7.22931C6.60331 7.56509 5.24065 8.2401 3.86991 9.60736C3.78604 9.69127 3.67822 9.74731 3.56118 9.76784C3.44414 9.78836 3.3236 9.77237 3.21603 9.72203C3.10846 9.6717 3.0191 9.58949 2.96019 9.48663C2.90127 9.38378 2.87566 9.2653 2.88686 9.14739C3.05186 7.34085 3.5803 6.02304 4.29914 5.07319C4.91642 4.25368 5.75476 3.62595 6.71639 3.26321C7.3369 3.02941 7.99089 2.89587 8.65365 2.86763V0.575825C8.65344 0.468066 8.68361 0.362414 8.74073 0.27092C8.79786 0.179426 8.87963 0.105772 8.97672 0.0583577ZM0 4.02561C0 3.26316 0.303907 2.53194 0.844866 1.9928C1.38582 1.45367 2.11952 1.15079 2.88455 1.15079H5.19219C5.3452 1.15079 5.49194 1.21137 5.60013 1.31919C5.70832 1.42702 5.7691 1.57326 5.7691 1.72575C5.7691 1.87824 5.70832 2.02449 5.60013 2.13231C5.49194 2.24014 5.3452 2.30072 5.19219 2.30072H2.88455C2.42553 2.30072 1.98531 2.48245 1.66074 2.80593C1.33616 3.12941 1.15382 3.56814 1.15382 4.02561V10.9252C1.15382 11.3826 1.33616 11.8214 1.66074 12.1449C1.98531 12.4683 2.42553 12.6501 2.88455 12.6501H9.80747C10.2665 12.6501 10.7067 12.4683 11.0313 12.1449C11.3559 11.8214 11.5382 11.3826 11.5382 10.9252V9.77525C11.5382 9.62276 11.599 9.47652 11.7072 9.36869C11.8154 9.26086 11.9621 9.20029 12.1151 9.20029C12.2681 9.20029 12.4149 9.26086 12.5231 9.36869C12.6312 9.47652 12.692 9.62276 12.692 9.77525V10.9252C12.692 11.6876 12.3881 12.4189 11.8472 12.958C11.3062 13.4971 10.5725 13.8 9.80747 13.8H2.88455C2.11952 13.8 1.38582 13.4971 0.844866 12.958C0.303907 12.4189 0 11.6876 0 10.9252V4.02561Z"
                  fill="white"
                />
              </svg>
            </span>
            <div
              className={`flex justify-end items-center gap-1 cursor-pointer select-none bg-[#28241F] rounded-2xl px-2 ${
                isWidthSmaller ? "text-xs" : " "
              }`}
              onClick={toggleLike}
            >
              {data.isLiked ? (
                <svg
                  width="14"
                  height="12"
                  viewBox="0 0 14 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.21249 1.09262C1.87666 0.428656 2.77733 0.0556641 3.71645 0.0556641C4.65558 0.0556641 5.55625 0.428656 6.22041 1.09262C6.35027 1.222 6.51744 1.38303 6.72191 1.5757C6.92591 1.38303 7.09284 1.222 7.2227 1.09262C7.88408 0.434342 8.77853 0.0636798 9.71166 0.0611807C10.6448 0.0586816 11.5412 0.424548 12.2061 1.07927C12.871 1.73399 13.2506 2.62466 13.2625 3.55772C13.2744 4.49078 12.9176 5.39084 12.2696 6.06228L7.222 11.1099C7.08916 11.2427 6.90903 11.3173 6.7212 11.3173C6.53338 11.3173 6.35324 11.2427 6.22041 11.1099L1.17283 6.06299C0.52544 5.39532 0.166648 4.49979 0.173937 3.56982C0.181226 2.63985 0.55472 1.75006 1.21249 1.09262Z"
                    fill="#FC0000"
                  />
                </svg>
              ) : (
                <svg
                  width="14"
                  height="12"
                  viewBox="0 0 14 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.21249 1.09262C1.87666 0.428656 2.77733 0.0556641 3.71645 0.0556641C4.65558 0.0556641 5.55625 0.428656 6.22041 1.09262C6.35027 1.222 6.51744 1.38303 6.72191 1.5757C6.92591 1.38303 7.09284 1.222 7.2227 1.09262C7.88408 0.434342 8.77853 0.0636798 9.71166 0.0611807C10.6448 0.0586816 11.5412 0.424548 12.2061 1.07927C12.871 1.73399 13.2506 2.62466 13.2625 3.55772C13.2744 4.49078 12.9176 5.39084 12.2696 6.06228L7.222 11.1099C7.08916 11.2427 6.90903 11.3173 6.7212 11.3173C6.53338 11.3173 6.35324 11.2427 6.22041 11.1099L1.17283 6.06299C0.52544 5.39532 0.166648 4.49979 0.173937 3.56982C0.181226 2.63985 0.55472 1.75006 1.21249 1.09262Z"
                    fill="#AAAAAA"
                  />
                </svg>
              )}
              <span>{data.nLike}</span>
            </div>
            <span
              className="w-7 h-7 inline-flex rounded-full flex-shrink-0 justify-center items-center bg-[#28241F] hover:bg-opacity-75 cursor-pointer"
              onClick={() => handleFavorite()}
            >
              {data.isFavorite ? (
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.9877 6.10805C16.0676 5.70836 15.7479 5.22873 15.3482 5.22873L10.7917 4.58922L8.71328 0.43243C8.63334 0.272553 8.5534 0.192615 8.39353 0.112676C7.99383 -0.127139 7.5142 0.032738 7.27439 0.43243L5.27593 4.58922L0.719445 5.22873C0.47963 5.22873 0.319753 5.30867 0.239815 5.46855C-0.0799383 5.7883 -0.0799383 6.26793 0.239815 6.58768L3.51729 9.78522L2.7179 14.3417C2.7179 14.5016 2.7179 14.6615 2.79784 14.8213C3.03766 15.221 3.51729 15.3809 3.91698 15.1411L7.99383 12.9827L12.0707 15.1411C12.1506 15.221 12.3105 15.221 12.4704 15.221H12.6303C13.0299 15.1411 13.3497 14.7414 13.2698 14.2618L12.4704 9.70528L15.7479 6.50774C15.9077 6.4278 15.9877 6.26793 15.9877 6.10805Z"
                    fill="#FFE600"
                  />
                </svg>
              ) : (
                <svg
                  width="18"
                  height="16"
                  viewBox="0 0 18 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.99959 0.0830078C9.15431 0.0830904 9.30595 0.126244 9.43753 0.207635C9.56911 0.289026 9.67543 0.40544 9.74459 0.543841L11.8946 4.84218L16.6196 5.52884C16.7735 5.55119 16.9181 5.61617 17.037 5.71643C17.1559 5.81668 17.2444 5.94822 17.2924 6.09614C17.3405 6.24407 17.3461 6.40249 17.3088 6.55347C17.2715 6.70446 17.1927 6.84199 17.0813 6.95051L13.6421 10.3038L14.4154 15.0322C14.4403 15.1852 14.4219 15.3422 14.3624 15.4854C14.3029 15.6286 14.2047 15.7524 14.0787 15.8428C13.9527 15.9332 13.804 15.9866 13.6493 15.9971C13.4945 16.0076 13.34 15.9747 13.2029 15.9022L8.99959 13.6722L4.79626 15.9022C4.65921 15.9747 4.50464 16.0076 4.34993 15.9971C4.19521 15.9866 4.0465 15.9332 3.92051 15.8428C3.79452 15.7524 3.69625 15.6286 3.63676 15.4854C3.57727 15.3422 3.55891 15.1852 3.58376 15.0322L4.35709 10.3038L0.917924 6.95051C0.806505 6.84199 0.727677 6.70446 0.690359 6.55347C0.653041 6.40249 0.658722 6.24407 0.706759 6.09614C0.754796 5.94822 0.843273 5.81668 0.962178 5.71643C1.08108 5.61617 1.22567 5.55119 1.37959 5.52884L6.10459 4.84218L8.25459 0.543841C8.32375 0.40544 8.43007 0.289026 8.56165 0.207635C8.69323 0.126244 8.84487 0.0830904 8.99959 0.0830078ZM8.99959 2.77967L7.40126 5.97634C7.34127 6.09656 7.25311 6.2005 7.14429 6.27929C7.03546 6.35808 6.9092 6.40939 6.77626 6.42884L3.28959 6.93551L5.83126 9.41301C5.92731 9.50659 5.99936 9.62197 6.04129 9.74935C6.08321 9.87672 6.09378 10.0123 6.07209 10.1447L5.49959 13.6422L8.60876 11.9922C8.72912 11.9283 8.86331 11.8948 8.99959 11.8948C9.13587 11.8948 9.27007 11.9283 9.39042 11.9922L12.4996 13.6422L11.9271 10.1447C11.9055 10.0125 11.9162 9.87702 11.9581 9.7498C12 9.62257 12.072 9.50733 12.1679 9.41384L14.7096 6.93551L11.2238 6.42884C11.0908 6.40939 10.9646 6.35808 10.8557 6.27929C10.7469 6.2005 10.6587 6.09656 10.5988 5.97634L8.99959 2.77967Z"
                    fill="white"
                  />
                </svg>
              )}
            </span>
          </div>
          <div
            className={`rounded-xl bg-[#28241F] py-2 ${
              isWidthSmaller ? "px-3" : "px-4"
            } mt-4 space-y-4 ${
              cardType === "detail"
                ? "flex-grow flex flex-col justify-center"
                : ""
            }`}
          >
            <div
              className={`text-center text-white ${
                isWidthSmaller ? "text-sm" : ""
              }`}
            >
              Comments
            </div>
            <div
              className={`space-y-4 overflow-clip transition-all duration-500 ${
                cardType === "detail"
                  ? `overflow-x-clip overflow-y-auto flex-grow max-h-72 xl:max-h-64 flex flex-col`
                  : showAll
                  ? "max-h-96"
                  : "h-[68px]"
              }`}
            >
              {!data.comments?.length && (
                <div className="flex flex-grow flex-col items-center gap-0 justify-center">
                  <p
                    className={`${
                      isWidthGreater && !isWidthSmaller ? "" : "text-sm"
                    } ${isWidthSmaller ? "text-[12px]" : ""}`}
                  >
                    No Comments Yet, Start Below
                  </p>
                </div>
              )}
              {getComments()?.map((d: any, index: number) => (
                <div
                  className="flex justify-between items-start gap-1"
                  key={index}
                >
                  <div className="flex flex-grow justify-start items-start gap-3">
                    <Link to={"/dashboard/profile"} className="flex-shrink-0">
                      <img
                        src={d?.user?.avatar}
                        className={`flex-shrink-0 ${
                          isWidthSmaller ? "w-9 h-9" : "w-10 h-10"
                        } rounded-full shadow object-cover object-center`}
                      />
                    </Link>
                    <div
                      className={`${
                        isWidthSmaller
                          ? "text-[10px]"
                          : isWidthGreater
                          ? ""
                          : "text-xs"
                      }`}
                    >
                      <div className="flex justify-start items-center gap-1">
                        <span className="font-bold">{d?.user?.name}</span>{" "}
                        {/* <span className="text-[#808191]">30min</span> */}
                      </div>
                      <div className="line-clamp-2">{d?.content}</div>
                    </div>
                  </div>
                  <div
                    className={`flex items-center flex-col gap-1 flex-shrink-0 select-none cursor-pointer ${
                      isWidthSmaller
                        ? "text-[10px] w-10"
                        : isWidthGreater
                        ? "w-[74px]"
                        : "text-xs  w-14"
                    }`}
                    onClick={() => handleCommentLike(d)}
                  >
                    {d?.isLiked ? (
                      <svg
                        width="14"
                        height="12"
                        viewBox="0 0 14 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M1.21249 1.09262C1.87666 0.428656 2.77733 0.0556641 3.71645 0.0556641C4.65558 0.0556641 5.55625 0.428656 6.22041 1.09262C6.35027 1.222 6.51744 1.38303 6.72191 1.5757C6.92591 1.38303 7.09284 1.222 7.2227 1.09262C7.88408 0.434342 8.77853 0.0636798 9.71166 0.0611807C10.6448 0.0586816 11.5412 0.424548 12.2061 1.07927C12.871 1.73399 13.2506 2.62466 13.2625 3.55772C13.2744 4.49078 12.9176 5.39084 12.2696 6.06228L7.222 11.1099C7.08916 11.2427 6.90903 11.3173 6.7212 11.3173C6.53338 11.3173 6.35324 11.2427 6.22041 11.1099L1.17283 6.06299C0.52544 5.39532 0.166648 4.49979 0.173937 3.56982C0.181226 2.63985 0.55472 1.75006 1.21249 1.09262Z"
                          fill="#FC0000"
                        />
                      </svg>
                    ) : (
                      <svg
                        width="14"
                        height="12"
                        viewBox="0 0 14 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M1.21249 1.09262C1.87666 0.428656 2.77733 0.0556641 3.71645 0.0556641C4.65558 0.0556641 5.55625 0.428656 6.22041 1.09262C6.35027 1.222 6.51744 1.38303 6.72191 1.5757C6.92591 1.38303 7.09284 1.222 7.2227 1.09262C7.88408 0.434342 8.77853 0.0636798 9.71166 0.0611807C10.6448 0.0586816 11.5412 0.424548 12.2061 1.07927C12.871 1.73399 13.2506 2.62466 13.2625 3.55772C13.2744 4.49078 12.9176 5.39084 12.2696 6.06228L7.222 11.1099C7.08916 11.2427 6.90903 11.3173 6.7212 11.3173C6.53338 11.3173 6.35324 11.2427 6.22041 11.1099L1.17283 6.06299C0.52544 5.39532 0.166648 4.49979 0.173937 3.56982C0.181226 2.63985 0.55472 1.75006 1.21249 1.09262Z"
                          fill="#AAAAAA"
                        />
                      </svg>
                    )}
                    <span className="whitespace-nowrap">{d?.nLike} likes</span>
                  </div>
                </div>
              ))}
            </div>
            {(showAll || !data.comments?.length || cardType === "detail") && (
              <Editor sendMessage={sendMessage} />
            )}
            {data?.comments?.length > 0 && cardType !== "detail" && (
              <button
                className={`flex mx-auto text-white select-none ${
                  isWidthSmaller ? "text-sm" : ""
                }`}
                onClick={() => setShowAll(!showAll)}
              >
                {showAll ? "Hide" : "View All"}
              </button>
            )}
          </div>
          <div
            className={`${
              data?.extras ? "visible" : "invisible"
            } mt-2 rounded-3xl overflow-clip flex justify-between text-white font-bold  ${
              isWidthGreater ? "text-lg" : isWidthSmaller ? "text-xs" : ""
            } `}
          >
            <button className="flex-1 py-0.5 bg-black flex justify-center items-center gap-1">
              <img
                src="/img/content/letter_logo.png"
                className="w-8"
                alt="logo"
              />
              Editor's Pick
            </button>
            <button
              className={`flex-1 py-0.5 ${
                data?.extras?.title === "New" ? "bg-[#65A64E]" : "bg-[#E56116]"
              }`}
            >
              {data?.extras?.title || ""}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
export default MediaCard;
